// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"48bd9111","200":"4e4cdfbb","214":"b46c1f97","394":"7e990e59","407":"1aa547ed","453":"0c1e7915","474":"cc3aa283","610":"10075c30","611":"3dc75c8a","616":"d3496cbf","711":"f5d5bb1f","825":"481ae36c","944":"b4c06f06"}[chunkId] + ".chunk.js";
};